import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=b6de4bfa&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6de4bfa')) {
      api.createRecord('b6de4bfa', component.options)
    } else {
      api.reload('b6de4bfa', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=b6de4bfa&", function () {
      api.rerender('b6de4bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tCSgwwHD1ZS6/JS/imageCarousel.vue"
export default component.exports